// Titik per desain (Desain Bordir): isi awal dari titik pesanan, "+ Tambah Desain", koreksi Owner/Admin beralasan.
import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const MAX_TITIK = 20;
const box = { position: "fixed", inset: 0, background: "rgba(15,23,42,.45)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1000 };
const card = { background: "#fff", borderRadius: 12, padding: 18, width: "min(520px, 94vw)", maxHeight: "90vh", overflowY: "auto", display: "grid", gap: 10 };

export function validateDesigns(rows) {
  if (!rows.length) return "Isi minimal 1 desain";
  for (let i = 0; i < rows.length; i++) {
    const n = Number(rows[i].titik);
    if (rows[i].titik === "" || rows[i].titik == null || !Number.isInteger(n) || n < 1 || n > MAX_TITIK)
      return `Desain ${i + 1}: isi jumlah titik (1–${MAX_TITIK})`;
  }
  return "";
}

export const totalTitik = (rows) => rows.reduce((a, r) => a + (Number(r.titik) || 0), 0);

function Row({ r, i, set, remove, canRemove }) {
  return <div style={{ display: "grid", gridTemplateColumns: "1fr 84px auto", gap: 6, alignItems: "center" }} data-testid={`design-points-row-${i}`}>
    <div style={{ display: "grid", gap: 2 }}>
      <input value={r.label} maxLength={80} onChange={e => set(i, { label: e.target.value })} placeholder={`Desain ${i + 1} (mis. dada kiri)`} data-testid={`design-points-label-${i}`} />
      {r.hint && <small style={{ color: "#64748b" }}>{r.hint}</small>}
    </div>
    <input type="number" min={1} max={MAX_TITIK} value={r.titik ?? ""} placeholder="titik"
      onChange={e => set(i, { titik: e.target.value === "" ? "" : Number(e.target.value) })} data-testid={`design-points-titik-${i}`} />
    <button type="button" className="soft-btn small-btn" disabled={!canRemove} onClick={() => remove(i)} data-testid={`design-points-remove-${i}`}>Hapus</button>
  </div>;
}

export function DesignPointsDialog({ target, mode = "done", label, onSubmit, onClose }) {
  const [rows, setRows] = useState(null);
  const [saved, setSaved] = useState(null);
  const [reason, setReason] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  useEffect(() => {
    axios.get(`${API}/shopee/embroidery/design-points/prefill`, { params: target, withCredentials: true, timeout: 30_000 })
      .then(r => { setSaved(r.data.saved); setRows(r.data.designs.map(d => ({ ...d, titik: d.titik ?? "" }))); })
      .catch(e => { setErr(e?.response?.data?.detail || "Titik pesanan gagal dimuat — isi manual."); setRows([{ label: "Desain A", titik: "" }]); });
  }, [target]);
  const set = (i, patch) => setRows(rs => rs.map((r, k) => k === i ? { ...r, ...patch } : r));
  const invalid = rows ? validateDesigns(rows) || (mode === "correct" && reason.trim().length < 5 ? "Alasan koreksi wajib (min. 5 karakter)" : "") : "Memuat…";
  const submit = async () => {
    if (busy || invalid) return;
    setBusy(true); setErr("");
    try { await onSubmit(rows.map(r => ({ label: (r.label || "").trim(), titik: Number(r.titik) })), reason.trim()); }
    catch (e) { setErr(e?.response?.data?.detail || e?.message || "Gagal menyimpan"); }
    finally { setBusy(false); }
  };
  return <div style={box} onClick={e => { e.stopPropagation(); if (!busy) onClose(); }} data-testid="design-points-dialog">
    <div style={card} onClick={e => e.stopPropagation()}>
      <b style={{ fontSize: 16 }}>{mode === "correct" ? "Koreksi Titik Desain" : "Selesai Desain — Titik per Desain"}</b>
      <small style={{ color: "#475569" }}>{label}</small>
      <small style={{ color: "#475569" }}>Isi 1 baris per desain berbeda. Jumlah pcs tidak mengalikan titik.
        {saved && mode !== "correct" ? " Daftar ini MENGGANTIKAN daftar sebelumnya (tidak ditambah)." : ""}</small>
      {!rows ? <small data-testid="design-points-loading">Memuat titik dari pesanan…</small> : <>
        {rows.map((r, i) => <Row key={i} r={r} i={i} set={set} canRemove={rows.length > 1} remove={k => setRows(rs => rs.filter((_, j) => j !== k))} />)}
        <button type="button" className="soft-btn small-btn" style={{ justifySelf: "start" }} disabled={rows.length >= 30}
          onClick={() => setRows(rs => [...rs, { label: `Desain ${String.fromCharCode(65 + rs.length)}`, titik: "" }])} data-testid="design-points-add">+ Tambah Desain</button>
        <div data-testid="design-points-total"><b>{rows.length}</b> desain · <b>{totalTitik(rows)}</b> titik</div>
      </>}
      {mode === "correct" && <textarea value={reason} onChange={e => setReason(e.target.value)} rows={2} maxLength={300}
        placeholder="Alasan koreksi (wajib)" data-testid="design-points-reason" />}
      {(err || (rows && invalid)) && <small style={{ color: "#b91c1c" }} data-testid="design-points-error">{err || invalid}</small>}
      <div style={{ display: "flex", gap: 8, justifyContent: "flex-end" }}>
        <button className="soft-btn small-btn" onClick={onClose} disabled={busy} data-testid="design-points-cancel">Batal</button>
        <button className="primary small-btn" onClick={submit} disabled={busy || !!invalid} data-testid="design-points-submit">
          {busy ? "Menyimpan…" : mode === "correct" ? "Simpan Koreksi" : "Simpan & Selesai Desain"}</button>
      </div>
    </div>
  </div>;
}
